export default class FCLoggger {
  static info = async (message) => await FCLoggger.logMessage("info", message);

  static error = async (message) =>
    await FCLoggger.logMessage("error", message);

  static debug = async (message) =>
    await FCLoggger.logMessage("debug", message);

  static basePath = "";

  static setup = (basePath) => {
    FCLoggger.basePath = basePath;
  };

  static getLogsURL = () => {
    FCLoggger.basePath + "/rs/agent/logMessenger";
  };

  static logMessage = async (level, message) => {
    console.log(`${level} : ${message}`);
    //   let url = `${FCLoggger.getLogsURL()}?message=${message}&level=${level}`;
    //   let fetchOptions = {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     cache: "no-cache",
    //   };
    //   try {
    //     const response = await fetch(url, fetchOptions);
    //     console.log(`Message logged`);
    //     return response;
    //   } catch (error) {
    //     console.log(
    //       `Error trying to post logs ${error} to URL ${FCLoggger.getLogsURL()}`
    //     );
    //   }
  };
}
